import { CSSProperties } from 'react';
import { useLingui } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import Stack from '@/design_system/Stack';
import IconAdd from '@/icons/Add.svg';
import IconSubtract from '@/icons/Subtract.svg';
import IconTrash from '@/icons/Trash.svg';
import { createBEMClasses } from '@/utils/classname';

import './InputQuantity.css';

const { block, element } = createBEMClasses('input-quantity');

const InputQuantity = ({
  quantity,
  onDecrement,
  onIncrement,
  disableDelete = false,
  disableRemove = false,
  disableAdd = false,
  isDisabled,
  size = 'small',
  variant = 'default',
  style,
}: {
  quantity: number;
  onDecrement?: () => void;
  onIncrement?: () => void;
  disableDelete?: boolean;
  disableRemove?: boolean;
  disableAdd?: boolean;
  isDisabled?: boolean;
  size?: 'small' | 'medium' | 'large';
  variant?: 'brand' | 'default';
  style?: CSSProperties;
}) => {
  const { t } = useLingui();

  return (
    <Stack row flexWrap="nowrap" alignItems="center" style={style} className={block({ size })}>
      {!isDisabled && (
        <Button
          iconOnly
          size={size}
          variant={variant === 'brand' ? 'secondary-brand' : 'secondary'}
          onPress={onDecrement}
          tooltip={t({ id: 'components.input-quantity.remove', message: 'Remove' })}
          ariaLabel={t({ id: 'components.input-quantity.remove', message: 'Remove' })}
          disabled={disableRemove || (disableDelete && quantity === 1)}
        >
          {quantity === 1 && !disableDelete ? <IconTrash /> : <IconSubtract />}
        </Button>
      )}
      <div className={element('quantity')}>{quantity}</div>
      {!isDisabled && (
        <Button
          iconOnly
          size={size}
          variant={variant === 'brand' ? 'secondary-brand' : 'secondary'}
          onPress={onIncrement}
          tooltip={t({ id: 'components.input-quantity.add', message: 'Add' })}
          ariaLabel={t({ id: 'components.input-quantity.add', message: 'Add' })}
          disabled={disableAdd}
        >
          <IconAdd />
        </Button>
      )}
    </Stack>
  );
};

export default InputQuantity;
